/**
 * @description Block types
 * Model correspond to IndexedDB schema
 * Import correspond to file import schema
 */
import * as io from "io-ts";
import { nullable, pick, timestamp, uuid } from "diagnostics-lib/io";
import { BlockTextImport, BlockTextModel } from "./block/text";
import { BlockHeadingImport, BlockHeadingModel } from "./block/heading";
import { BlockTableImport, BlockTableModel } from "./block/table";
import { BlockPlotImport, BlockPlotModel } from "./block/plot";
import { BlockImageImport, BlockImageModel } from "./block/image";
import { BlockDiagramImport, BlockDiagramModel } from "./block/diagram";
import { BlockCommentImport, BlockCommentModel } from "./block/comment";
import { BlockPresetImport, BlockPresetModel } from "./block/preset";
/**
 * @description Generic dashboard type
 */
const GenericDashboard = <C extends io.Mixed>(blocks: C) =>
  io.type({
    createdByUserId: uuid,
    createdByUserName: nullable(io.string),
    updatedByUserName: nullable(io.string),
    createdAt: timestamp,
    updatedAt: nullable(timestamp),
    blocks,
    description: io.union([io.string, io.null]),
    id: uuid,
    projectId: uuid,
    published: io.boolean,
    readonly: io.union([io.boolean, io.undefined]),
    title: io.string,
  });

/**
 * @description Dashboard types
 */
export const DashboardBlockImport = io.union([
  BlockDiagramImport,
  BlockHeadingImport,
  BlockImageImport,
  BlockPlotImport,
  BlockTableImport,
  BlockTextImport,
  BlockCommentImport,
  BlockPresetImport,
]);

export const DashboardBlockModel = io.union([
  BlockDiagramModel,
  BlockHeadingModel,
  BlockImageModel,
  BlockPlotModel,
  BlockTableModel,
  BlockTextModel,
  BlockCommentModel,
  BlockPresetModel,
]);

export const DashboardModel = GenericDashboard(io.array(uuid));

export const DashboardImport = pick(GenericDashboard(io.array(DashboardBlockImport)), [
  "blocks",
  "title",
  "description",
]);

export type DashboardBlockImportT = io.TypeOf<typeof DashboardBlockImport>;
export type DashboardBlockModelT = io.TypeOf<typeof DashboardBlockModel>;
export type DashboardModelT = io.TypeOf<typeof DashboardModel>;
export type DashboardImportT = io.TypeOf<typeof DashboardImport>;
